import React from "react";
import { HashLoader } from "react-spinners";

export const HashSpinner = ({ style }) => {
  return (
    <HashLoader
      color="#000000"
      //    style={style}
    />
  );
};
